import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Chip, IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useCampaignData from "@/hooks/data/use-campaign-data";
import usePopOver from "@/hooks/use-popover";
import { ICampaign } from "@/interfaces/campaign.interface";
import { CampaignsMessages } from "@/messages/campaigns/campaigns.messages";

import { CampaignPopover } from "../CampaignPopover";

interface Props {
  campaign: ICampaign;
  index: number;
  messages: CampaignsMessages;
}

export function CampaignTableRow({ campaign, index, messages }: Props) {
  const campaignData = useCampaignData({ campaign, messages });
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<ICampaign>();

  return (
    <TableRow index={index} key={index}>
      <TableCell>{campaignData.code}</TableCell>
      <TableCell>{campaignData.name}</TableCell>
      <TableCell>{campaignData.typeLabel}</TableCell>
      <TableCell>{campaignData.startDateFormatted}</TableCell>
      <TableCell>{campaignData.endDateFormatted}</TableCell>
      <TableCell>
        <Chip
          label={campaignData.statusLabel.toUpperCase()}
          color={campaignData.bgColor}
          variant="outlined"
        />
      </TableCell>
      <TableCell>
        <IconButton onClick={(e) => openPopover(e, campaign)}>
          <MoreHorizIcon />
        </IconButton>

        {selected && (
          <CampaignPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
